import React from 'react';

function Discussion(props){

    return <div className="hello">

        <div className="hi"> Click on Find Expert for more info .<br/> Your Discussion is Empty</div>

</div>




}

export default Discussion;